import React, { Suspense } from 'react';
import { Router as BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from 'react-helmet-async';

import RouterConfiguration from 'configurations/router';
import { history, persistor, queryClient, store } from 'configurations/redux-store';
import { ADMIN_BLOCK_PREVIEW_PATH } from 'constants/admin-route-paths';

const BackJobsWrapper = React.lazy(() => import('components/backjobs-wrapper'));

const App = () => (
  <HelmetProvider>
    <BrowserRouter history={history}>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <QueryClientProvider client={queryClient}>
            {window.location.pathname !== ADMIN_BLOCK_PREVIEW_PATH && (
              <Suspense fallback={null}>
                <BackJobsWrapper />
              </Suspense>
            )}
            <RouterConfiguration />
          </QueryClientProvider>
        </PersistGate>
      </Provider>
    </BrowserRouter>
  </HelmetProvider>
);

export default App;
